import actionsFactory from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'
import { fetchPath } from '../../utils/api'
import { loadContactBasket, loadAdditionalBasketData, createBasketLine } from '../../utils/api/basket'
import yodaFormatter from '../../utils/api/yodaFormatter'

const actions = actionsFactory({
  fetchPath,
  loadContactBasket,
  loadAdditionalBasketData,
  yodaFormatter,
  createBasketLine,
})

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
